import { Container, Typography, Grid } from "@mui/material";
import CopyContact from "./CopyContact";
import GithubButton from "./SocialButtons/GithubButton";
import LinkedInButton from "./SocialButtons/LinkedInButton";
import TelegramButton from "./SocialButtons/TelegramButton";
import YouTubeButton from "./SocialButtons/YoutubeButton";

function Contacts() {
  return (
    <>
      <Container maxWidth="lg" sx={{ my: 5 }}>
        <Grid container spacing={6}>
          <Grid item size={12}>
            <Typography variant="h3">My contacts</Typography>
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 6 }}
            display="flex"
            justifyContent="center"
          >
            <CopyContact contact="hello@vladhere.com" />
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 6 }}
            display="flex"
            justifyContent="center"
          >
            <CopyContact contact="+44 7857 999 352" />
          </Grid>
          <Grid item size={12} display="flex" justifyContent="center">
            <Typography variant="h4">Follow my socials:</Typography>
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            display="flex"
            justifyContent="space-evenly"
          >
            <GithubButton />
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            display="flex"
            justifyContent="space-evenly"
          >
            <LinkedInButton />
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            display="flex"
            justifyContent="space-evenly"
          >
            <TelegramButton />
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            display="flex"
            justifyContent="space-evenly"
          >
            <YouTubeButton />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Contacts;
